<template>
  <div class="default_layout" data-scroll data-scroll-section>
    <Scroll>
    <Header/>

    <router-view :key="$route.fullPath" />
    <Footer/>
    </Scroll>
  </div>
</template>
 

<script>
  import Header from '@/components/modules/Header';
  import Footer from '@/components/modules/Footer';
  import Scroll from '@/components/Scroll';

  export default {
    components: {
      Header,
      Footer,
      Scroll,
    },
  };
</script>
